module.exports = __webpack_public_path__ + "src/images/measurements/calfCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/calfCircumference.jpg
// module id = 1144
// module chunks = 0